import { propertyAssetService } from '@/services/api/propertyAsset.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { propertyAssetModel } from '@/models/api/propertyAsset.model';
import { propertyAssetStatisticSummaryModel } from '@/models/api/propertyAssetStatisticSummary.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    statisticSummary: {},
    status: {
        list: true,
        detail: true,
        save: true,
        statisticSummary: true,
    },
};

export const PROPERTY_ASSET_MODULE = "api/propertyAsset";

// ACTIONS
export const GET_ALL_PROPERTY_ASSET = 'getAllPropertyAsset';
export const GET_PROPERTY_ASSET_STATISTIC_SUMMARY = 'getPropertyAssetStatisticSummary';
export const CREATE_PROPERTY_ASSET = 'createPropertyAsset';
export const GET_PROPERTY_ASSET = 'getPropertyAsset';
export const UPDATE_PROPERTY_ASSET = 'updatePropertyAsset';
export const UPDATE_PROPERTY_ASSET_STATUS = 'updatePropertyAssetStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_PROPERTY_ASSET_SUCCESS = "allPropertyAssetSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_PROPERTY_ASSET_SUCCESS = "getPropertyAssetSuccess";
const PROPERTY_ASSET_STATISTIC_SUMMARY_SUCCESS = "propertyAssetStatisticSummarySuccess";

export const actions = {
    [GET_PROPERTY_ASSET_STATISTIC_SUMMARY]({commit}) {
        commit(REQUESTING, 'statisticSummary');
        return propertyAssetService
            .statisticSummary()
            .then((result) => {
                commit(PROPERTY_ASSET_STATISTIC_SUMMARY_SUCCESS, result);
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_ALL_PROPERTY_ASSET]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        propertyAssetService
            .getAll(filter)
            .then((result) => {
                commit(ALL_PROPERTY_ASSET_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_PROPERTY_ASSET]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return propertyAssetService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_ASSET, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_PROPERTY_ASSET]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return propertyAssetService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_PROPERTY_ASSET_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_PROPERTY_ASSET]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return propertyAssetService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_ASSET, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_PROPERTY_ASSET_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return propertyAssetService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_ASSET, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [PROPERTY_ASSET_STATISTIC_SUMMARY_SUCCESS](state, data) {
        state.statisticSummary = data.success && data.data ? propertyAssetStatisticSummaryModel(data.data) : {};
    },
    [ALL_PROPERTY_ASSET_SUCCESS](state, {data}) {
        let propertyAsset = data.data || [];
        state.list.data = propertyAsset;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = propertyAsset.map(item => propertyAssetModel(item));
        }
    },
    [GET_PROPERTY_ASSET_SUCCESS](state, data) {
        state.details = propertyAssetModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
            statisticSummary: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
            statisticSummary: true,
        };
    },
};
